import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';
import { USER_TYPE } from '../../../@core/models/enums';
import { DEACTIVATION_STATUS, IShareUser } from '../../../@core/models/model';
import { ToastService } from '../../../@core/services/toast.service';
import { ApprovalConfService } from '../../../contract-management/services/approval-conf.service';
import { CheckScreenSize } from '../../../services/check-screen-size.service';
import { DateFormatterPipe } from '../../pipes/dateFormater.pipe';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { BadgeComponent } from "../badge/badge.component";
import { CONTRACT_STATUS } from '../badge/badge.enums';
import { CONTRACT_APPROVAL_STATUS } from '../user-chips/user-chips.component';
import { ButtonComponent } from '../../../@core/components/ui/button/button.component';
import { TextCasePipe } from "../../pipes/textCase.pipe";
import { UserNameDisplayComponent } from 'src/app/@shared/components/user-name-display';


export enum FLOW_TYPE {
  APPROVAL = 'APPROVAL',
  SIGNATORY = 'SIGNATORY'
}
@Component({
  selector: 'app-approval-workflow',
  standalone: true,
  imports: [TimelineModule, ButtonComponent, BadgeComponent, CardModule, DateFormatterPipe, ButtonModule, CommonModule, TooltipModule, TruncatePipe, AccordionModule, TextCasePipe, UserNameDisplayComponent],
  templateUrl: './approval-workflow.component.html',
  styleUrl: './approval-workflow.component.scss'
})

export class ApprovalWorkflowComponent {
  @Input() approvers !: IShareUser[]
  @Input() canEdit: boolean = false
  @Output() deleteApproverEvent = new EventEmitter<string>()
  @Output() deleteSignatoryEvent = new EventEmitter<string>()
  @Output() downloadSignatoryEvent = new EventEmitter<{ email: string, name: string, status: string, signedAttachment?: string }>()
  @Input() signatories !: { email: string, name: string, status: string, signedAttachment?: string }[]
  @Input() flowType !: FLOW_TYPE
  @Input() contractStatus !: CONTRACT_STATUS

  CONTRACT_STATUS = CONTRACT_STATUS
  FLOW_TYPE = FLOW_TYPE
  APPROVAL_STATUS !: CONTRACT_APPROVAL_STATUS
  USER_TYPE = USER_TYPE
  isSmallScreen: boolean = false
  DEACTIVATION_STATUS = DEACTIVATION_STATUS;

  constructor(
    private approvalService: ApprovalConfService,
    private toast: ToastService,
    private checkScreenSizeService: CheckScreenSize
  ) {
  }

  ngOnInit() {
    this.isSmallScreen = this.checkScreenSizeService.checkScreenSize()
  }

  deleteSignatory(email: string) {
    this.deleteSignatoryEvent.emit(email)
  }

  async downloadSignedDocument(signatory: { email: string, name: string, status: string, signedAttachment?: string }) {
    this.downloadSignatoryEvent.emit(signatory)
  }

  isUserUnverified(item: any): boolean {
    return item && item.user && typeof item.user !== 'string' && item.user.verified === false;
  }

}
